import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { Money } from 'ha/services/apiV2/types/common';
import {
  Settlement,
  SettlementExternalRefType,
} from 'ha/services/apiV2/types/Settlement';

export type Payload = {
  buyerAccountUuid: string;
  sellerAccountUuid: string;
  externalReferenceType: SettlementExternalRefType;
  externalReference: string;
  purchaseValue: Money;
};

export default (makeCall: MakeCall) => (data: Payload) =>
  makeCall<Settlement>('POST', `/api/v2/payment/settlement`, { data });
